"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsControlsStyleComplexUnit_1 = __importDefault(require("../../typeAssertions/valueIsControlsStyleComplexUnit"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const computeComplexUnit = (onCompatibilityIssue) => (complexUnit) => {
    if ((0, valueIsString_1.default)(complexUnit)) {
        return Number(complexUnit);
    }
    if ((0, valueIsControlsStyleComplexUnit_1.default)(complexUnit)) {
        const { unit, value } = complexUnit;
        let newUnit = unit;
        if (!['px', '%'].includes(unit)) {
            onCompatibilityIssue('INVALID_COMPLEX_UNIT', '::', 'px');
            newUnit = 'px';
        }
        if (newUnit === 'px') {
            return Number(value);
        }
        return `${value}${newUnit}`;
    }
    return complexUnit || 0;
};
exports.default = computeComplexUnit;
